import { render, staticRenderFns } from "./ServiceFeeForm.vue?vue&type=template&id=12648872&"
import script from "./ServiceFeeForm.vue?vue&type=script&lang=js&"
export * from "./ServiceFeeForm.vue?vue&type=script&lang=js&"
import style0 from "./ServiceFeeForm.vue?vue&type=style&index=0&id=12648872&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports